import { Link } from 'react-router-dom';
import { films } from '@/mocks/films';

const footerGroups = [
  {
    title: '浏览',
    links: [
      { label: '首页', to: '/' },
      { label: '最新电影', to: '/category/movie' },
      { label: '热门电视剧', to: '/category/tv' },
    ],
  },
  {
    title: '发现',
    links: [
      { label: '搜索影视', to: '/search' },
      { label: '关于我们', to: '/about' },
    ],
  },
];

export default function SiteFooter() {
  const latestYear = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 lg:px-12 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950 font-heading font-bold">
                同
              </span>
              <div>
                <p className="font-heading text-lg font-bold text-background-50">同学的妈妈</p>
                <p className="font-label text-[11px] uppercase tracking-[0.2em] text-primary-300">
                  Film Archive
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-primary-200">
              一个认真介绍影视作品的内容站。我们整理影片资料、分段的剧情介绍与演职员信息，帮助你在按下播放键之前，先想清楚要不要看。
            </p>
            <p className="mt-4 font-label text-xs text-primary-300">
              目前收录 {films.filter((f) => f.type === 'movie').length} 部电影 ·{' '}
              {films.filter((f) => f.type === 'tv').length} 部剧集
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title} className="md:col-span-2">
              <p className="font-label text-xs uppercase tracking-[0.18em] text-primary-300">
                {group.title}
              </p>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-primary-100 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <p className="font-label text-xs uppercase tracking-[0.18em] text-primary-300">声明</p>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              本站所有影视资料、图片与文字均为内容演示用途，不存储、不提供任何影音文件，亦不提供播放与下载服务。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-primary-300">
            © {latestYear} 同学的妈妈 · 影视大全与剧情介绍
          </p>
          <p className="font-label text-xs text-primary-300">
            内容仅供观影参考 · 转载请注明出处
          </p>
        </div>
      </div>
      <div className="h-16 md:hidden" />
    </footer>
  );
}